module.exports = __webpack_public_path__ + "img/logo.acafe8fb.png";